export var AllocationRule;
(function (AllocationRule) {
    AllocationRule["ByCommitmentAndClosingDate"] = "ByCommitmentAndClosingDate";
    AllocationRule["Manual"] = "Manual";
    AllocationRule["LinkedAction"] = "LinkedAction";
    AllocationRule["ApprovedFees"] = "ApprovedFees";
    AllocationRule["PerOriginalInvestment"] = "PerOriginalInvestment";
    AllocationRule["ProRata"] = "ProRata";
    AllocationRule["Reconciliation"] = "Reconciliation";
})(AllocationRule || (AllocationRule = {}));
//# sourceMappingURL=index.js.map